import { MembersResponse, UserProfile } from '@shared/types/user';
import api from '../../../shared/services/api';


export class MembersService {
  private static readonly BASE_URL = '/members';

  /**
   * Get list of members with optional search and pagination
   */
  static async getMembers(
    page = 1,
    limit = 10,
    search = ''
  ): Promise<MembersResponse> {
    try {
      const response = await api.get<MembersResponse>(this.BASE_URL, {
        params: { page, limit, search },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching members:', error);
      throw error;
    }
  }

  /**
   * Get detailed profile of a specific member
   */
  static async getMemberProfile(userId: string): Promise<UserProfile> {
    try {
      const response = await api.get<UserProfile>(`${this.BASE_URL}/${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching member profile for user ${userId}:`, error);
      throw error;
    }
  }
}
